import React from 'react';
import { DragSource } from 'react-dnd';

const cardSource = {
  beginDrag(props) {
    return {
      employee: props.employee,
      shift: props.shiftItem,
    };
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

const DayEmployee = ({ employee, shiftItem, isDragging, connectDragSource }) => {
  return connectDragSource(
    <div className={`DayEmployees__Employee ${isDragging ? 'is-dragging' : ''}`} key={employee.id}>
      {employee.name}
    </div>
  );
};

export default DragSource('day', cardSource, collect)(DayEmployee);



// WEBPACK FOOTER //
// ./src/components/DayModal/DayEmployee.js